import React, { useState, useContext } from 'react';
import { FormControl, MenuItem, Select } from '@material-ui/core';
import { ReportContext } from '../Context/ReportContext';
import { SET_API_PARAM } from '../Context/constants';
export const SelectParam = ({
  param
}) => {
  const {
    values,
    defaultValue,
    apiParam
  } = param;
  const {
    dispatch,
    apiParams
  } = useContext(ReportContext);
  const [selectedParam, setSelectedParam] = useState(defaultValue);

  const listAttributeMenuItems = () => values.map(value => {
    const displayName = value === null || value === void 0 ? void 0 : value.display;
    const displayValue = value === null || value === void 0 ? void 0 : value.value;
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: `param-${displayValue}`,
      value: displayValue,
      style: {
        fontSize: '.9rem'
      }
    }, displayName);
  });

  return /*#__PURE__*/React.createElement(FormControl, {
    style: {
      paddingLeft: '3px',
      minWidth: '70px'
    }
  }, /*#__PURE__*/React.createElement(Select, {
    value: selectedParam || '',
    style: {
      fontSize: '.9rem'
    },
    onChange: event => {
      setSelectedParam(event.target.value);
      dispatch({
        type: SET_API_PARAM,
        payload: {
          id: apiParam,
          value: event.target.value
        }
      });
    }
  }, values && listAttributeMenuItems()));
};